import styled from "styled-components";

export const PaymentGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 5fr 1fr;
`;
